export default __webpack_public_path__ + "static/media/Rectangle 3748.f4f65ccc.png";